var __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

define(['jquery', 'underscore', 'mixin', 'core', 'app-common/component/loader', 'app-common/component/notification', 'app-common/component/validation', 'app-common/component/region-control', 'app-common/view/dialog', 'app-common/view/model-update', 'template/address/landing.htm', 'common/lib/forms/chosen.jquery', 'common/lib/forms/jquery.placeholder'], function($, _, mixin, core, loader, NotificationSupport, validation, regionControl, DialogView, ModelUpdateView, landingTemplate) {
  var AddressPage;
  return AddressPage = (function(_super) {

    __extends(AddressPage, _super);

    function AddressPage() {
      AddressPage.__super__.constructor.apply(this, arguments);
    }

    AddressPage.prototype.pageId = 'address';

    AddressPage.prototype.notificationSelector = function() {
      return '#dialog-window .notification-area';
    };

    AddressPage.prototype.initialize = function(options, params) {
      this.model = core.getModel('address');
      this.clientModel = core.getCurrentClient();
      return this.render();
    };

    AddressPage.prototype.render = function() {
      var _this = this;
      AddressPage.__super__.render.call(this, _.template(landingTemplate, this.model.toJSON()));
      $('#address-form').submit(function(e) {
        e.preventDefault();
        return _this.saveAddress();
      });
      new ModelUpdateView({
        el: $('#address-form'),
        model: this.model
      });
      this.initAddressValidation();
      this.initRegionControl();
      this.initNotifications();
      this.$el.find('#province').chosen({
        disable_search: true
      });
      this.$el.find('.chzn-container').addClass('short');
      return $('#address-form input[type="text"]').placeholder();
    };

    AddressPage.prototype.remove = function() {
      this.hideNotifications();
      return AddressPage.__super__.remove.apply(this, arguments);
    };

    AddressPage.prototype.initAddressValidation = function() {
      validation.addRules({
        streetLine1: {
          requiredWP: true
        },
        phone: {
          requiredWP: true
        },
        city: {
          requiredWP: true
        },
        postalCode: {
          requiredWP: true,
          checkCAorUSAPostalCode: true
        }
      });
      return validation.init($('#address-form'));
    };

    AddressPage.prototype.initRegionControl = function() {
      regionControl.init(this.$el.find('#province'), null, this.model.get('province'));
      return regionControl.redrawOptions(this.clientModel.get('countryCode'));
    };

    AddressPage.prototype.initNotifications = function() {
      return this.setNotifications({
        save_success: {
          type: 'success',
          text: 'Your address was successfully updated.'
        },
        save_error: {
          type: 'error',
          text: 'Couldn\'t update address.'
        }
      });
    };

    AddressPage.prototype.saveAddress = function() {
      var promise,
        _this = this;
      if (!$('#address-form').valid()) {
        return;
      }
      loader.init({
        dialog: true
      });
      promise = this.model.save();
      promise.always(function() {
        return loader.hide();
      });
      promise.done(function() {
        return _this.showNotification('save_success');
      });
      return promise.fail(function() {
        return _this.showNotification('save_error');
      });
    };

    return AddressPage;

  })(mixin.of(DialogView, NotificationSupport));
});
